import * as TipoRival from "../constantes/TipoRival.js";

export const TiposRival = [
  {id: TipoRival.CLUB, descripcion: "Club"},
  {id: TipoRival.EQUIPO, descripcion: "Equipo"},
];

export const ArmarRival = (tipo, objeto) => {
  return {
    tipo: tipo,
    objeto: objeto,
  }
};

export const EncontrarRival = (idTipo) => {
  return TiposRival.find((item) => item.id === idTipo);
}

export const getIdRival = (rival) => {
  return rival && rival.objeto && rival.objeto.id;
}

export const getIdTipoRival = (rival) => {
  return rival && rival.tipo && rival.tipo.id;
}

export const GetRival = (rival) => {
  return rival && rival.objeto;
}

export const GetTipoRival = (rival) => {
  return rival && rival.tipo;
}

